import React from 'react'
import gql from 'graphql-tag'
import { Query } from 'react-apollo'
import { MetadataFilter } from '../filter-manager/metadata-filter-manager'

export const evaluateTracesQuery = gql`
  query evaluateTraces(
    $organizationID: ID!
    $traces: [ID!]!
    $status: String!
  ) {
    adminApprovalEvaluateTraces(
      input: {
        organizationID: $organizationID
        traces: $traces
        status: $status
      }
    ) {
      result
    }
  }
`

export const evaluateTracesByFiltersQuery = gql`
  query evaluateTracesByFilters(
    $organizationID: ID!
    $filters: VulnerabilityFilterArg!
    $status: String!
  ) {
    adminApprovalEvaluateTracesByFilters(
      input: {
        organizationID: $organizationID
        filters: $filters
        status: $status
      }
    ) {
      result
    }
  }
`

interface Filters {
  readonly filterText: string
  readonly quickFilter: string
  readonly aggregations: Record<string, string[]>
}

interface RequiredStatusToggleProps {
  readonly organizationID: string
  readonly traceIDs: string[]
  readonly statusName: string
  readonly filters?: Filters
  readonly additionalFilters?: { readonly [key: string]: any }
  readonly isStatusApprovalEnabled: boolean
  readonly children: (required: boolean) => React.ReactElement<any>
}

export function RequiredStatusToggle({
  organizationID,
  traceIDs,
  statusName,
  filters,
  additionalFilters,
  isStatusApprovalEnabled,
  children
}: RequiredStatusToggleProps) {
  return !isStatusApprovalEnabled ? (
    children(false)
  ) : filters ? (
    <Query<
      {
        readonly adminApprovalEvaluateTracesByFilters: {
          readonly result: boolean
        }
      },
      {
        readonly organizationID: string
        readonly filters: Record<string, string[] | MetadataFilter[]> & {
          readonly filterText: string
          readonly quickFilter: string
        }
        readonly status: string
      }
    >
      variables={{
        organizationID,
        filters: Object.assign({}, filters.aggregations, {
          filterText: filters.filterText,
          quickFilter: filters.quickFilter,
          ...additionalFilters
        }),
        status: statusName
      }}
      query={evaluateTracesByFiltersQuery}
      errorPolicy="all"
    >
      {({ loading, error, data }) => {
        if (loading || error || !data) {
          return false
        }

        return children(data.adminApprovalEvaluateTracesByFilters.result)
      }}
    </Query>
  ) : (
    <Query<
      {
        readonly adminApprovalEvaluateTraces: { readonly result: boolean }
      },
      {
        readonly organizationID: string
        readonly traces: string[]
        readonly status: string
      }
    >
      variables={{
        organizationID,
        traces: traceIDs,
        status: statusName
      }}
      query={evaluateTracesQuery}
    >
      {({ loading, error, data }) => {
        if (loading || error || !data) {
          return false
        }

        return children(data.adminApprovalEvaluateTraces.result)
      }}
    </Query>
  )
}
